import React from "react";
import { render } from "react-dom";
import { classNamePrefix as prefixCt } from "@/utils/common";
import { AttachmentProvider } from "@/providers/attachmentProvider";
import AttachmentView from "../components/attachmentView";
import "../index.less";

function transform(node, config) {
  const src = node.getAttribute("data-src");

  let align = "left";
  if (node.getAttribute("class").includes("center")) align = "center";
  if (node.getAttribute("class").includes("right")) align = "right";

  const nameNode = node.querySelector(".name");
  const sizeNode = node.querySelector(".size");
  const size = sizeNode.innerText;

  let name = "file";
  if (nameNode && !nameNode.getAttribute("title")) {
    name = nameNode && nameNode.innerText;
    nameNode.setAttribute("title", name);
  } else {
    name = nameNode.getAttribute("title");
  }

  const attachmentProvider = new AttachmentProvider();
  if (config.copyCallback) {
    attachmentProvider.copyCallback = config.copyCallback;
  }
  const attrs = { name, size, src, align };
  const newNode = document.createElement("div");
  node.parentNode.insertBefore(newNode, node.nextSibling);
  render(
    <AttachmentView
      view={null}
      getPos={() => 0}
      node={null}
      attrs={attrs}
      dom={null}
      provider={attachmentProvider}
    />,
    newNode
  );
  node.parentNode.removeChild(node);
}

export default class attachmentRender {
  fragmentCls: string;

  config: Record<string, any>;

  constructor(config = {}) {
    this.fragmentCls = `.${prefixCt("attachment")}`;
    this.config = config;
  }

  fragmentRender = (node: HTMLElement) => {
    transform(node, this.config);
  };
}
